import { DEFAULT_LOCALE, LOCALE_COOKIE, isLocale, type Locale } from './config';

function readCookie(name: string): string | undefined {
  if (typeof document === 'undefined') return undefined;
  const match = document.cookie.match(
    new RegExp(`(?:^|; )${name}=([^;]*)`),
  );
  return match ? decodeURIComponent(match[1]) : undefined;
}

/**
 * Resolve the locale to render with on the client.
 *
 * Priority:
 *   1. Explicit choice in the `queri_lang` cookie (set by the switcher, and
 *      shared with the marketing site).
 *   2. The browser's preferred languages (e.g. a Swedish browser -> Swedish).
 *   3. The default locale.
 */
export function resolveInitialLocale(): Locale {
  const cookie = readCookie(LOCALE_COOKIE);
  if (isLocale(cookie)) return cookie;

  if (typeof navigator !== 'undefined') {
    const preferred = navigator.languages?.length
      ? navigator.languages
      : [navigator.language];
    for (const lang of preferred) {
      const base = lang?.toLowerCase().split('-')[0];
      if (isLocale(base)) return base;
    }
  }

  return DEFAULT_LOCALE;
}
